export const ROUTES = {
  login: "/login",
  workspace: "/workspace",
  profileCompletion: "/profile-completion",
  incomingCalls: "/calls/incoming",
  callHistory: "/calls/history",
  profile: "/profile",
  profileInstagram: "/profile/instagram",
  profilePrivatePhotos: "/profile/private-photos",
  profilePrivateVideos: "/profile/private-videos",
  withdraw: "/withdraw",
  settings: "/settings",
} as const;
